import { render } from "./KSKandidatiEng.vue?vue&type=template&id=8ecce048&scoped=true&lang=html"
import script from "./KSKandidatiEng.vue?vue&type=script&lang=js"
export * from "./KSKandidatiEng.vue?vue&type=script&lang=js"

import "./KSKandidatiEng.vue?vue&type=style&index=0&id=8ecce048&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-8ecce048"

export default script